import { API, graphqlOperation, Storage } from 'aws-amplify';
import { Dispatch } from 'redux';
import { searchProductswithimagekey } from '../../../graphql/custom_queries';
import * as customQueries from '../../../graphql/custom_queries';
import * as queries from '../../../graphql/queries';
import { Product } from '../types';
import {
  addBrandProducts,
  getBrandInfoStart,
  receiveBrandDetails,
  getBrandProductsStart,
  receiveBrandProductsNextToken,
  getSignedBrandProductsStart,
  setBrandProducts,
} from './../actions/details';
import { executeQuery } from '~utils/graphql';
import { getImageUrl } from '~utils/image';
import { getQueryFilter } from '~utils/search';

export const getBrandInfo = (brandId: string, unAuth?: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch(getBrandInfoStart());

    const data = await executeQuery(
      unAuth ? customQueries.getBrandUnAuth : customQueries.getBrand,
      {
        id: brandId,
      },
      unAuth
    );
    const brandData = data.data.getBrandReadModel;

    const signedUrl = await getImageUrl(brandData.brand_imageKey);
    brandData.imageUrl = signedUrl;
    const iconUrl = await getImageUrl(brandData.brand_icon_imageKey);
    brandData.iconUrl = iconUrl;
    if (brandData.brand_modal_imageKeys?.length) {
      const modalImageUrl = await Promise.all(
        brandData.brand_modal_imageKeys?.map(async (imageKey: string) =>
          imageKey ? await getImageUrl(imageKey) : ''
        )
      );
      brandData.modalImageUrl = modalImageUrl;
    }

    dispatch(receiveBrandDetails(brandData));
  };
};

export const getSaleBrandInfo = () => {
  return async (dispatch: Dispatch<any>) => {
    const response = await API.graphql<any>(
      graphqlOperation(queries.searchBrands, {
        filter: { id: { eq: process.env.REACT_APP_HOMULA_BRAND_ID } },
        sort: { direction: 'asc', field: 'createdAt' },
      })
    );
    const {
      data: {
        searchBrands: { items: brands },
      },
    } = response;
    const brand = brands[0];

    if (!brand || !brand.id) {
      return;
    }

    dispatch(getBrandInfo(brand.id));
  };
};

export const getBrandInfoPrevie = (brandId: string) => {
  return async (dispatch: Dispatch) => {
    dispatch(getBrandInfoStart());

    const data = await API.graphql<any>(
      graphqlOperation(queries.getBrand, {
        id: brandId,
      })
    );
    const brandData = data.data.getBrand;
    const signedUrl = await Storage.get(brandData.brand_imageKey);
    brandData.imageUrl = signedUrl;

    dispatch(receiveBrandDetails(brandData));
  };
};

type Options = {
  sort?: {
    field: string;
    direction: 'asc' | 'desc';
  };
  filter?: {
    product_category?: { match: string };
    id?: { eq?: string; ne?: string };
  };
  limit?: number;
  nextToken?: string;
};

export const getProducts = (
  brandId: string,
  keyword?: string,
  options?: Options,
  all?: boolean,
  unAuth?: boolean
) => {
  return async (dispatch: Dispatch) => {
    dispatch(getBrandProductsStart());

    let filter: any = {
      ...options?.filter,
      product_brand_id: { eq: brandId },
      // product_public_status: { eq: '公開' },
      suspended: { ne: true },
    };

    if (!all) {
      filter = {
        ...filter,
        product_public_status: { eq: '公開' },
      };
    }

    if (keyword) {
      filter = {
        ...filter,
        ...{
          or: [
            { product_name: { match: keyword } },
            { product_name: { wildcard: `*${keyword}*` } },
          ],
        },
      };
    }

    const products: any[] = [];
    let _nextToken = options?.nextToken?.replaceAll('Infinity', '"Infinity"');
    do {
      const productData: any = await executeQuery(
        unAuth
          ? customQueries.searchProductswithimagekeyUnAuth
          : searchProductswithimagekey,
        {
          ...options,
          filter,
          nextToken: _nextToken,
        },
        unAuth
      );
      const {
        data: {
          searchProducts: { nextToken, items },
        },
      } = productData;
      _nextToken = nextToken;
      products.push(...items);
    } while (all && _nextToken);

    dispatch(receiveBrandProductsNextToken(_nextToken));
    getSignedProducts(products, !options?.nextToken)(dispatch);
  };
};

export const getProductsPreview = (brandId: string, options?: Options) => {
  return async (dispatch: Dispatch) => {
    dispatch(getBrandProductsStart());

    if (options?.nextToken) {
      options = {
        ...options,
        nextToken: options.nextToken.replaceAll('Infinity', '"Infinity"'),
      };
    }

    const productData = await API.graphql<any>(
      graphqlOperation(customQueries.searchProductswithimagekeyPreview, {
        ...options,
        filter: {
          ...options?.filter,
          product_brand_id: { eq: brandId },
          product_public_status: { eq: '公開' },
          suspended: { ne: true },
        },
      })
    );
    const {
      data: {
        searchProducts: { nextToken, items },
      },
    } = productData;

    dispatch(receiveBrandProductsNextToken(nextToken));
    getSignedProducts(items, !options?.nextToken)(dispatch);
  };
};

export const getSignedProducts = (products: Product[], replace?: boolean) => {
  return async (dispatch: Dispatch) => {
    dispatch(getSignedBrandProductsStart());

    const signedProducts = await Promise.all(
      products.map(async (item: any) => {
        if (item.imageKeys?.items[0]?.imageKey) {
          item.imageUrl = await getImageUrl(item.imageKeys?.items[0]?.imageKey);
        } else {
          item.imageUrl = 'https://placehold.jp/200x200.png?text=No image';
        }
        return item;
      })
    );

    if (replace) {
      dispatch(setBrandProducts(signedProducts));
      return;
    }

    dispatch(addBrandProducts(signedProducts));
  };
};
